import { captureException } from "@sentry/browser";
import { vMaska } from "maska/vue";
import { createApp } from "vue";
import App from "./App.vue";

export function createOrderFormApp() {
	try {
		const app = createApp(App);

		app.directive("maska", vMaska);
		app.mount("#order-form");
	} catch (error) {
		captureException(error);
	}
}
